import AccessibilityCheckmark from 'owa-fluent-icons-svg/lib/icons/AccessibilityCheckmarkRegular';
import AppsAddIn from 'owa-fluent-icons-svg/lib/icons/AppsAddInRegular';
import Archive from 'owa-fluent-icons-svg/lib/icons/ArchiveRegular';
import ArchiveSettings from 'owa-fluent-icons-svg/lib/icons/ArchiveSettingsRegular';
import ArrowDown from 'owa-fluent-icons-svg/lib/icons/ArrowDownRegular';
import ArrowForward from 'owa-fluent-icons-svg/lib/icons/ArrowForwardRegular';
import ArrowRepeatAllOff from 'owa-fluent-icons-svg/lib/icons/ArrowRepeatAllOffRegular';
import ArrowRepeatAll from 'owa-fluent-icons-svg/lib/icons/ArrowRepeatAllRegular';
import ArrowReplyAll from 'owa-fluent-icons-svg/lib/icons/ArrowReplyAllRegular';
import ArrowReply from 'owa-fluent-icons-svg/lib/icons/ArrowReplyRegular';
import Undo from 'owa-fluent-icons-svg/lib/icons/ArrowUndoRegular';
import Attach from 'owa-fluent-icons-svg/lib/icons/AttachRegular';
import SubtractCircleRegular from 'owa-fluent-icons-svg/lib/icons/SubtractCircleRegular';
import Broom from 'owa-fluent-icons-svg/lib/icons/BroomRegular';
import CalendarReply from 'owa-fluent-icons-svg/lib/icons/CalendarReplyRegular';
import Classification from 'owa-fluent-icons-svg/lib/icons/ClassificationRegular';
import ClipboardDataBar from 'owa-fluent-icons-svg/lib/icons/ClipboardDataBarRegular';
import ClipboardPaste from 'owa-fluent-icons-svg/lib/icons/ClipboardPasteRegular';
import Clock from 'owa-fluent-icons-svg/lib/icons/ClockRegular';
import CloudArrowDown from 'owa-fluent-icons-svg/lib/icons/CloudArrowDownRegular';
import CloudOff from 'owa-fluent-icons-svg/lib/icons/CloudOffRegular';
import Color from 'owa-fluent-icons-svg/lib/icons/ColorRegular';
import ContactCard from 'owa-fluent-icons-svg/lib/icons/ContactCardRegular';
import Delete from 'owa-fluent-icons-svg/lib/icons/DeleteRegular';
import Flag from 'owa-fluent-icons-svg/lib/icons/FlagRegular';
import FolderArrowRight from 'owa-fluent-icons-svg/lib/icons/FolderArrowRightRegular';
import FolderMail from 'owa-fluent-icons-svg/lib/icons/FolderMailRegular';
import FolderSwap from 'owa-fluent-icons-svg/lib/icons/FolderSwapRegular';
import ImmersiveReader from 'owa-fluent-icons-svg/lib/icons/ImmersiveReaderRegular';
import Important from 'owa-fluent-icons-svg/lib/icons/ImportantRegular';
import LightbulbFilament from 'owa-fluent-icons-svg/lib/icons/LightbulbFilamentRegular';
import LineHorizontal3 from 'owa-fluent-icons-svg/lib/icons/LineHorizontal3Regular';
import Link from 'owa-fluent-icons-svg/lib/icons/LinkRegular';
import LockClosed from 'owa-fluent-icons-svg/lib/icons/LockClosedRegular';
import MailProhibited from 'owa-fluent-icons-svg/lib/icons/MailProhibitedRegular';
import MailRead from 'owa-fluent-icons-svg/lib/icons/MailReadRegular';
import Mail from 'owa-fluent-icons-svg/lib/icons/MailRegular';
import MailSettings from 'owa-fluent-icons-svg/lib/icons/MailSettingsRegular';
import Mic from 'owa-fluent-icons-svg/lib/icons/MicRegular';
import Note from 'owa-fluent-icons-svg/lib/icons/NoteRegular';
import PaintBrush from 'owa-fluent-icons-svg/lib/icons/PaintBrushRegular';
import PeopleCheckmark from 'owa-fluent-icons-svg/lib/icons/PeopleCheckmarkRegular';
import PeopleCommunity from 'owa-fluent-icons-svg/lib/icons/PeopleCommunityRegular';
import Poll from 'owa-fluent-icons-svg/lib/icons/PollRegular';
import Picture from 'owa-fluent-icons-svg/lib/icons/PictureInPictureRegular';
import Unpin from 'owa-fluent-icons-svg/lib/icons/PinRegular';
import Print from 'owa-fluent-icons-svg/lib/icons/PrintRegular';
import Prohibited from 'owa-fluent-icons-svg/lib/icons/ProhibitedRegular';
import ReadAloud from 'owa-fluent-icons-svg/lib/icons/ReadAloudRegular';
import Save from 'owa-fluent-icons-svg/lib/icons/SaveRegular';
import Send from 'owa-fluent-icons-svg/lib/icons/SendRegular';
import Settings from 'owa-fluent-icons-svg/lib/icons/SettingsRegular';
import Signature from 'owa-fluent-icons-svg/lib/icons/SignatureRegular';
import Table from 'owa-fluent-icons-svg/lib/icons/TableRegular';
import Tag from 'owa-fluent-icons-svg/lib/icons/TagRegular';
import Warning from 'owa-fluent-icons-svg/lib/icons/WarningRegular';
import WarningShield from 'owa-fluent-icons-svg/lib/icons/WarningShieldRegular';
import MailAttachRegular from 'owa-fluent-icons-svg/lib/icons/MailAttachRegular';
import PlayThisConverstion from 'owa-cortana-pme/lib/components/icons/PlayThisConversation';
import loc from 'owa-localize';
import AccessibilityCheckerStrings from 'owa-locstrings/lib/strings/acccheckermenuitemtext.locstring.json';
import ChangeNoteColorStrings from 'owa-locstrings/lib/strings/changenotecolormenutext.locstring.json';
import ViewEmailFromNoteStrings from 'owa-locstrings/lib/strings/viewemailfromnotelabel.locstring.json';
import DiscardStrings from 'owa-locstrings/lib/strings/composediscardbutton.locstring.json';
import ComposeStrings from 'owa-locstrings/lib/strings/composesendbutton.locstring.json';
import DeleteStrings from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import PlayMyEmails from 'owa-locstrings/lib/strings/playmyemailscharm_arialabel.locstring.json';
import HighImportanceStrings from 'owa-locstrings/lib/strings/highimportancemenutext.locstring.json';
import LowImportanceStrings from 'owa-locstrings/lib/strings/lowimportancemenutext.locstring.json';
import NormalImportanceStrings from 'owa-locstrings/lib/strings/normalimportancemenutext.locstring.json';
import Strings from 'owa-locstrings/lib/strings/ribbon_mail_buttons_and_tabs.locstring.json';
import SplitbuttonStrings from 'owa-locstrings/lib/strings/ribbon_mail_split_dropbuttons.locstring.json';
import SetImportanceStrings from 'owa-locstrings/lib/strings/setimportance.locstring.json';
import ShowFromStrings from 'owa-locstrings/lib/strings/showfrom.locstring.json';
import MessageSettingsStrings from 'owa-locstrings/lib/strings/showmessageoptions.locstring.json';
import SwitchToPlainTextMenuItemStrings from 'owa-locstrings/lib/strings/switchtoplaintextmenuitem.locstring.json';
import SensitivityStrings from 'owa-mail-commands/lib/utils/sensitivityMenu.locstring.json';
import type { ComposeViewState } from 'owa-mail-compose-store';
import CommandBarStrings from 'owa-locstrings/lib/strings/commandBarStrings.locstring.json';
import { MenuItemType } from 'owa-filterable-menu';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import getIsEverythingSelectedInTable from 'owa-mail-list-store/lib/selectors/getIsEverythingSelectedInTable';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import getEmptyFolderText from 'owa-mail-list-store/lib/utils/getEmptyFolderText';
import { RibbonControlId, ActionControlId, MailRibbonControlId } from 'owa-ribbon-ids';
import { ControlInfo } from './controlInfo';
import { getHoverTooltip } from './HoverTooltips/getHoverTooltip';
import { options_readingPane_quickSetting_label } from 'owa-reading-pane-option/lib/lazyQuickOption.locstring.json';
import isReplyAllTheDefaultResponse from 'owa-mail-reading-pane-store/lib/utils/isReplyAllTheDefaultResponse';
import MailMultipleRegular from 'owa-fluent-icons-svg/lib/icons/MailMultipleRegular';
import MailListRegular from 'owa-fluent-icons-svg/lib/icons/MailListRegular';
import TextDensityRegular from 'owa-fluent-icons-svg/lib/icons/TextDensityRegular';
import PanelLeftRegular from 'owa-fluent-icons-svg/lib/icons/PanelLeftRegular';
import PanelLeftFilled from 'owa-fluent-icons-svg/lib/icons/PanelLeftFilled';
import PanelLeftFocusRightFilled from 'owa-fluent-icons-svg/lib/icons/PanelLeftFocusRightFilled';
import EmojiRegular from 'owa-fluent-icons-svg/lib/icons/EmojiRegular';

/**
 * Retrieves the display information pertaining to a given mail ribbon
 * control
 * @param controlId for which to retrieve the display information for
 * @returns display information for passed in control
 */
export function getControlInfo(
    controlId: RibbonControlId,
    viewState?: ComposeViewState
): ControlInfo {
    switch (controlId) {
        //home tab controls
        case MailRibbonControlId.RespondReply: {
            const controlName: string = loc(Strings.replyToEmail_Button);

            return {
                iconName: ArrowReply,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ToggleLeftPane: {
            const controlName: string = loc(Strings.toggleLeftPane_Button);

            return {
                iconName: LineHorizontal3,
                text: controlName,
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        }

        case MailRibbonControlId.NewMessage: {
            const controlName: string = loc(Strings.newEMailMessage_Button);

            return {
                iconName: Mail,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.NewMessageSplitButton: {
            const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();

            if (shouldShowBehaviorMap != undefined) {
                const isNote: boolean = shouldShowBehaviorMap[MenuItemType.Ribbon_NewNote]();

                if (isNote) {
                    return {
                        iconName: Note,
                        text: loc(Strings.newNote_HeroButton),
                        ariaText: undefined,
                        tooltip: undefined,
                        hasChevron: false,
                    };
                }
            }

            const controlName: string = loc(Strings.newMessage_Button);
            const controlSplitBtn: string = loc(SplitbuttonStrings.newMessage_SplitButton);

            return {
                iconName: Mail,
                text: controlName,
                ariaText: controlSplitBtn,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.DeleteItem: {
            const tableViewId: string = listViewStore.selectedTableViewId;
            const tableView = listViewStore.tableViews.get(tableViewId)!;
            const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
            let controlName: string;

            if (
                getIsEverythingSelectedInTable(tableView) ||
                shouldShowBehaviorMap[MenuItemType.EmptyFolder]()
            ) {
                controlName = getEmptyFolderText(tableView);
            } else {
                controlName = loc(DeleteStrings.deleteItem);
            }

            const controlSplitBtn: string = loc(SplitbuttonStrings.delete_SplitButton);

            return {
                iconName: Delete,
                text: controlName,
                ariaText: controlSplitBtn,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Archive: {
            const controlName: string = loc(Strings.archiveEmail_Button);

            return {
                iconName: Archive,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Sweep: {
            const controlName: string = loc(Strings.sweepEmail_Button);

            return {
                iconName: Broom,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Move: {
            const controlName: string = loc(Strings.move_FlyoutButton);

            return {
                iconName: FolderArrowRight,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.JunkFlyout:
        case MailRibbonControlId.JunkNotJunk: {
            const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
            const controlName: string =
                shouldShowBehaviorMap[MenuItemType.MarkAsJunk]() ||
                !shouldShowBehaviorMap[MenuItemType.Ribbon_JunkNotJunk]()
                    ? loc(Strings.junk_Button)
                    : loc(Strings.notJunk_Button);

            return {
                iconName: Prohibited,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(MailRibbonControlId.JunkNotJunk, controlName),
                hasChevron: controlId === MailRibbonControlId.JunkFlyout,
            };
        }

        case MailRibbonControlId.Phishing: {
            const controlName: string = loc(Strings.phishing_Button);

            return {
                iconName: Warning,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Block: {
            const controlName: string = loc(Strings.block_Button);

            return {
                iconName: SubtractCircleRegular,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.IgnoreStopIgnore: {
            const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
            const controlName =
                !shouldShowBehaviorMap ||
                shouldShowBehaviorMap[MenuItemType.Ignore]() ||
                !shouldShowBehaviorMap[MenuItemType.Ribbon_IgnoreStopIgnore]()
                    ? loc(Strings.ignoreEmail_Button)
                    : loc(Strings.stopIgnoringEmail_Button);

            return {
                iconName: MailProhibited,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Rules: {
            const controlName: string = loc(Strings.rules_FlyoutButton);

            return {
                iconName: FolderMail,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.RespondReplyAll: {
            const controlName: string = loc(Strings.replyAllToEmail_Button);

            return {
                iconName: ArrowReplyAll,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Respond: {
            const isReplyAll = isReplyAllTheDefaultResponse();
            const controlSplitBtn: string = loc(SplitbuttonStrings.respond_SplitButton);

            return {
                iconName: isReplyAll ? ArrowReply : ArrowReplyAll,
                text: isReplyAll
                    ? loc(Strings.replyAllToEmail_Button)
                    : loc(Strings.replyToEmail_Button),
                ariaText: controlSplitBtn,
                tooltip: undefined,
                hasChevron: false,
            };
        }

        case MailRibbonControlId.RespondForward: {
            const controlName: string = loc(Strings.replyForwardEmail_Button);

            return {
                iconName: ArrowForward,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }
        case MailRibbonControlId.RespondForwardEmailAsAttachment: {
            const controlName: string = loc(Strings.replyForwardEmailAsAttachment_Button);

            return {
                iconName: MailAttachRegular,
                text: controlName,
                ariaText: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ReplyWithMeeting: {
            const controlName: string = loc(Strings.replyMeetingToEmail_Button);

            return {
                iconName: CalendarReply,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ReadUnread: {
            const controlName: string = loc(Strings.readUnread_Button);

            return {
                iconName: MailRead,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Categorize: {
            const controlName: string = loc(Strings.categorize_FlyoutButton);

            return {
                iconName: Tag,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.PinUnpin: {
            const controlName: string = loc(Strings.pinUnpin_Button);

            return {
                iconName: Unpin,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Snooze: {
            const controlName: string = loc(Strings.snooze_Button);

            return {
                iconName: Clock,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.CreateRule: {
            const controlName: string = loc(Strings.createRule_Button);

            return {
                iconName: FolderMail,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ManageRules: {
            const controlName: string = loc(Strings.manageRules_Button);

            return {
                iconName: Settings,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.BrowseGroups: {
            const controlName: string = loc(Strings.browseGroups_Button);

            return {
                iconName: PeopleCommunity,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Undo: {
            const controlName: string = loc(Strings.undo_Button);

            return {
                iconName: Undo,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case ActionControlId.GetAddIns: {
            const controlName: string = loc(Strings.getAddIns_Button);

            return {
                iconName: AppsAddIn,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Insights:
            return {
                iconName: LightbulbFilament,
                text: loc(Strings.insights_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.ReportMessage:
            return {
                iconName: WarningShield,
                text: loc(Strings.reportMessage_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        case MailRibbonControlId.ManageQuickSteps:
            return {
                iconName: Settings,
                text: loc(Strings.manageQuickSteps_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        // view tab controls
        case MailRibbonControlId.ViewSettings: {
            const controlName: string = loc(Strings.viewSettings_Button);

            return {
                iconName: Settings,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Conversations: {
            const controlName: string = loc(Strings.conversations_Button);

            return {
                iconName: MailMultipleRegular,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.MessagePreview: {
            const controlName: string = loc(Strings.messagePreview_Button);

            return {
                iconName: MailListRegular,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Layout: {
            const controlName: string = loc(Strings.layout_Button);

            return {
                iconName: PanelLeftRegular,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case MailRibbonControlId.FolderPane: {
            const controlName: string = loc(Strings.folder_Button);

            return {
                iconName: PanelLeftFilled,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case MailRibbonControlId.ReadingPane: {
            const controlName: string = loc(options_readingPane_quickSetting_label);

            return {
                iconName: PanelLeftFocusRightFilled,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case MailRibbonControlId.Density: {
            const controlName: string = loc(Strings.density_Button);

            return {
                iconName: TextDensityRegular,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case MailRibbonControlId.Messages: {
            const controlName: string = loc(Strings.messages_Button);
            return {
                iconName: Mail,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        //message tab controls
        case MailRibbonControlId.Paste:
            return {
                iconName: ClipboardPaste,
                text: loc(Strings.paste_FlyoutButton),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: true,
            };
        case MailRibbonControlId.ShowHideFrom:
            return {
                iconName: '', // Icon "on order" from fluent
                text: loc(ShowFromStrings.showFrom),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        case MailRibbonControlId.FormatPainter:
            return {
                iconName: PaintBrush,
                text: loc(Strings.formatPainter_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        case MailRibbonControlId.CheckNames: {
            const controlName: string = loc(Strings.checkNames_Button);

            return {
                iconName: PeopleCheckmark,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.AttachFile: {
            const controlName: string = loc(Strings.attachFile_FlyoutButton);

            return {
                iconName: Attach,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.AttachSig: {
            const controlName: string = loc(Strings.attachSig_FlyoutButton);

            return {
                iconName: Signature,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case ActionControlId.Sensitivity: {
            const controlName: string = loc(Strings.sensitivity_FlyoutButton);

            return {
                iconName: Classification,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case ActionControlId.Sensitivity_LearnMore: {
            const controlName: string = loc(SensitivityStrings.clpLabelDropDownLearnMoreButtonText);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.HighImportance: {
            const controlName: string = loc(Strings.highImportance_Button);

            return {
                iconName: Important,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.LowImportance: {
            const controlName: string = loc(Strings.lowImportance_Button);

            return {
                iconName: ArrowDown,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ToolbarHighImportance: {
            const controlName: string = loc(HighImportanceStrings.highImportanceMenuText);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ToolbarLowImportance: {
            const controlName: string = loc(LowImportanceStrings.lowImportanceMenuText);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ToolbarNormalImportance: {
            const controlName: string = loc(NormalImportanceStrings.normalImportanceMenuText);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.SetImportance:
            return {
                iconName: Important,
                text: loc(SetImportanceStrings.setImportance),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: true,
            };
        case MailRibbonControlId.ShowMessageOptions:
            return {
                iconName: MailSettings,
                text: loc(MessageSettingsStrings.showMessageOptions),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.SwitchDraftFormat:
            const buttonText: string =
                viewState && viewState.bodyType != 'HTML'
                    ? CommandBarStrings.switchToHTMLMenuItem
                    : SwitchToPlainTextMenuItemStrings.switchToPlainTextMenuItem;
            return {
                iconName: '', // Currently no icon, by design
                text: loc(buttonText),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.CheckForAccessibilityIssues:
            return {
                iconName: AccessibilityCheckmark,
                text: loc(AccessibilityCheckerStrings.accCheckerMenuItemText),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        case MailRibbonControlId.Dictate:
            return {
                iconName: Mic,
                text: loc(Strings.dictate_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        case MailRibbonControlId.ReadAloud: {
            const controlName: string = loc(Strings.readAloud_Button);

            return {
                iconName: ReadAloud,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Encrypt: {
            const controlName: string = loc(Strings.encrypt_FlyoutButton);

            return {
                iconName: LockClosed,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.Encrypt_SingleButton: {
            const controlName: string = loc(Strings.encrypt_FlyoutButton);

            return {
                iconName: LockClosed,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Save: {
            const controlName: string = loc(Strings.save_Button);

            return {
                iconName: Save,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.ShowLinkDialog: {
            const controlName: string = loc(Strings.insertLink_Button);

            return {
                iconName: Link,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        //send receive tab controls
        case MailRibbonControlId.SendReceiveAllFolders:
            return {
                iconName: ArrowRepeatAll,
                text: loc(Strings.sendReceiveAllFolders_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.SendAll:
            return {
                iconName: Send,
                text: loc(Strings.sendAll_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.UpdateFolder:
            return {
                iconName: FolderSwap,
                text: loc(Strings.updateFolder_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.SendReceiveGroups:
            return {
                iconName: FolderSwap,
                text: loc(Strings.sendReceiveGroups_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.SyncShowProgress:
            return {
                iconName: ClipboardDataBar,
                text: loc(Strings.showSyncProgress_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.SyncCancelAll:
            return {
                iconName: ArrowRepeatAllOff,
                text: loc(Strings.cancelSync_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.OfflineWorkOffline:
            return {
                iconName: CloudOff,
                text: loc(Strings.workOffline_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };
        case MailRibbonControlId.DownloadDownloadHeaders:
            return {
                iconName: CloudArrowDown,
                text: loc(Strings.downloadHeaders_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        //toolbar message tab
        case MailRibbonControlId.SendDraft: {
            const controlName: string = loc(ComposeStrings.composeSendButton);

            return {
                iconName: Send,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.DiscardDraft: {
            const controlName: string = loc(DiscardStrings.composeDiscardButton);

            return {
                iconName: Delete,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        //shared controls
        case MailRibbonControlId.Print:
            return {
                iconName: Print,
                text: loc(Strings.printMail_Button),
                ariaText: undefined,
                tooltip: undefined,
                hasChevron: false,
            };

        case MailRibbonControlId.ImmersiveReader: {
            const controlName: string = loc(Strings.immersiveReader_Button);

            return {
                iconName: ImmersiveReader,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.AssignPolicy: {
            const controlName: string = loc(Strings.assignPolicy_FlyoutButton);

            return {
                iconName: ArchiveSettings,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.MoreRetentionPolicies: {
            const controlName: string = loc(Strings.moreRetentionPoliciesOptions_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagClearFlag: {
            const controlName: string = loc(Strings.flagClearFlag_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagCompleteToday: {
            const controlName: string = loc(Strings.flagCompleteToday_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagCompleteTomorrow: {
            const controlName: string = loc(Strings.flagCompleteTomorrow_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagCompleteThisWeek: {
            const controlName: string = loc(Strings.flagCompleteThisWeek_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagCompleteNextWeek: {
            const controlName: string = loc(Strings.flagCompleteNextWeek_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagCompleteNoDate: {
            const controlName: string = loc(Strings.flagCompleteNoDate_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagMarkComplete: {
            const controlName: string = loc(Strings.flagMarkComplete_Button);

            return {
                iconName: undefined,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.FlagUnflag: {
            const controlName: string = loc(Strings.flagUnflag_Button);
            const controlSplitBtn: string = loc(SplitbuttonStrings.flagUnflag_SplitButton);

            return {
                iconName: Flag,
                text: controlName,
                ariaText: controlSplitBtn,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.AddressBook: {
            const controlName: string = loc(Strings.addressBook_Button);

            return {
                iconName: ContactCard,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.RibbonCustomizer: {
            const controlName: string = loc(Strings.ribbonCustomizer_Button);

            return {
                iconName: '',
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        //insert tab controls

        case MailRibbonControlId.Poll: {
            const controlName: string = loc(Strings.poll_Button);
            return {
                iconName: Poll,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case ActionControlId.InsertTable: {
            const controlName: string = loc(Strings.table_Button);
            return {
                iconName: Table,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case MailRibbonControlId.Pictures: {
            const controlName: string = loc(Strings.pictures_Button);
            return {
                iconName: Picture,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }
        case MailRibbonControlId.Emojis: {
            const controlName: string = loc(Strings.emojis_Button);
            return {
                iconName: EmojiRegular,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Notes_DeleteNote: {
            const controlName: string = loc(DeleteStrings.deleteItem);
            return {
                iconName: Delete,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.Notes_ChangeColor: {
            const controlName: string = loc(ChangeNoteColorStrings.changeNoteColorMenuText);
            return {
                iconName: Color,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: true,
            };
        }

        case MailRibbonControlId.Notes_ViewEmail: {
            const controlName: string = loc(ViewEmailFromNoteStrings.viewEmailFromNoteLabel);
            return {
                iconName: Mail,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        case MailRibbonControlId.PlayMyEmails: {
            const controlName: string = loc(PlayMyEmails.playmyemailsCharm_ariaLabel);
            return {
                iconName: PlayThisConverstion,
                text: controlName,
                ariaText: undefined,
                tooltip: getHoverTooltip(controlId, controlName),
                hasChevron: false,
            };
        }

        default:
            throw new Error(
                'The ribbon id ' +
                    controlId +
                    ' was not added to the switch case in getControlInfo.ts'
            );
    }
}
